import React from "react";
import { Button } from 'rsuite';
import './Btn.css';

const Btn = ({text, subtle, disabled, fluid, onClick, width, height, className}) => {
  return (
      <Button
      onClick={onClick}
      disabled={disabled}
      style={{width, height}}
      className={`${subtle ? "BtnSubtle" : "Btn"} ${fluid ? "fluid" : ""} ${className || ""}`}
    >
      <span className="paragraph-16M" style={{color: disabled ? "var(--Gray-400)" : "white"}}>{text}</span>
      </Button>
  );
};

export default Btn;
